{
    "nm": "Flow 6 - light",
    "ddd": 0,
    "h": 180,
    "w": 400,
    "meta": { "g": "LottieFiles Figma v90" },
    "layers": [
        {
            "ty": 0,
            "nm": "Swirl 1",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": true,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [44.5, 14.5] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [172.5, 55.5] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 0
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 36
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 54
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 90
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [100],
                            "t": 108
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [100],
                            "t": 144
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 162
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 198
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 216
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 252
                        },
                        {
                            "o": { "x": 0, "y": 0 },
                            "i": { "x": 1, "y": 1 },
                            "s": [0],
                            "t": 270
                        },
                        { "s": [0], "t": 306 }
                    ]
                }
            },
            "masksProperties": [
                {
                    "nm": "",
                    "inv": false,
                    "mode": "a",
                    "x": { "a": 0, "k": 0 },
                    "o": { "a": 0, "k": 100 },
                    "pt": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [89, 0],
                                            [89, 29],
                                            [0, 29],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [89, 0],
                                            [89, 29],
                                            [0, 29],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 36
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [89, 0],
                                            [89, 29],
                                            [0, 29],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 54
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [89, 0],
                                            [89, 29],
                                            [0, 29],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 90
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [89, 0],
                                            [89, 29],
                                            [0, 29],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 108
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [89, 0],
                                            [89, 29],
                                            [0, 29],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 144
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [89, 0],
                                            [89, 29],
                                            [0, 29],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 162
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [89, 0],
                                            [89, 29],
                                            [0, 29],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 198
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [89, 0],
                                            [89, 29],
                                            [0, 29],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 216
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [89, 0],
                                            [89, 29],
                                            [0, 29],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 252
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 1, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [89, 0],
                                            [89, 29],
                                            [0, 29],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 270
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [89, 0],
                                            [89, 29],
                                            [0, 29],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 306
                            }
                        ]
                    }
                }
            ],
            "w": 400,
            "h": 180,
            "refId": "1",
            "ind": 1
        },
        {
            "ty": 0,
            "nm": "check 1",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": true,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [24.5, 24] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [337.5, 66] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [100],
                            "t": 0
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [100],
                            "t": 36
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 54
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 90
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 108
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 144
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 162
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 198
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 216
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 252
                        },
                        {
                            "o": { "x": 0, "y": 0 },
                            "i": { "x": 1, "y": 1 },
                            "s": [100],
                            "t": 270
                        },
                        { "s": [100], "t": 306 }
                    ]
                }
            },
            "masksProperties": [
                {
                    "nm": "",
                    "inv": false,
                    "mode": "a",
                    "x": { "a": 0, "k": 0 },
                    "o": { "a": 0, "k": 100 },
                    "pt": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [49, 0],
                                            [49, 48],
                                            [0, 48],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [49, 0],
                                            [49, 48],
                                            [0, 48],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 36
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [49, 0],
                                            [49, 48],
                                            [0, 48],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 54
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [49, 0],
                                            [49, 48],
                                            [0, 48],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 90
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [49, 0],
                                            [49, 48],
                                            [0, 48],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 108
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [49, 0],
                                            [49, 48],
                                            [0, 48],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 144
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [49, 0],
                                            [49, 48],
                                            [0, 48],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 162
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [49, 0],
                                            [49, 48],
                                            [0, 48],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 198
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [49, 0],
                                            [49, 48],
                                            [0, 48],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 216
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [49, 0],
                                            [49, 48],
                                            [0, 48],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 252
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 1, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [49, 0],
                                            [49, 48],
                                            [0, 48],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 270
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [49, 0],
                                            [49, 48],
                                            [0, 48],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 306
                            }
                        ]
                    }
                }
            ],
            "w": 400,
            "h": 180,
            "refId": "2",
            "ind": 2
        },
        {
            "ty": 0,
            "nm": "Burst 1",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": true,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [19.5, 21.5] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [70.5, 68.5] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 0
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 36
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 54
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 90
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 108
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 144
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 162
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 198
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [100],
                            "t": 216
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [100],
                            "t": 252
                        },
                        {
                            "o": { "x": 0, "y": 0 },
                            "i": { "x": 1, "y": 1 },
                            "s": [0],
                            "t": 270
                        },
                        { "s": [0], "t": 306 }
                    ]
                }
            },
            "masksProperties": [
                {
                    "nm": "",
                    "inv": false,
                    "mode": "a",
                    "x": { "a": 0, "k": 0 },
                    "o": { "a": 0, "k": 100 },
                    "pt": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [39, 0],
                                            [39, 43],
                                            [0, 43],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [39, 0],
                                            [39, 43],
                                            [0, 43],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 36
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [39, 0],
                                            [39, 43],
                                            [0, 43],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 54
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [39, 0],
                                            [39, 43],
                                            [0, 43],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 90
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [39, 0],
                                            [39, 43],
                                            [0, 43],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 108
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [39, 0],
                                            [39, 43],
                                            [0, 43],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 144
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [39, 0],
                                            [39, 43],
                                            [0, 43],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 162
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [39, 0],
                                            [39, 43],
                                            [0, 43],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 198
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [39, 0],
                                            [39, 43],
                                            [0, 43],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 216
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [39, 0],
                                            [39, 43],
                                            [0, 43],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 252
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 1, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [39, 0],
                                            [39, 43],
                                            [0, 43],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 270
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [39, 0],
                                            [39, 43],
                                            [0, 43],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 306
                            }
                        ]
                    }
                }
            ],
            "w": 400,
            "h": 180,
            "refId": "3",
            "ind": 3
        },
        {
            "ty": 0,
            "nm": "Stars 1",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": true,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [60.5, 31] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [282.5, 144] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 0
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 36
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 54
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 90
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 108
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 144
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [100],
                            "t": 162
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [100],
                            "t": 198
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 216
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 252
                        },
                        {
                            "o": { "x": 0, "y": 0 },
                            "i": { "x": 1, "y": 1 },
                            "s": [0],
                            "t": 270
                        },
                        { "s": [0], "t": 306 }
                    ]
                }
            },
            "masksProperties": [
                {
                    "nm": "",
                    "inv": false,
                    "mode": "a",
                    "x": { "a": 0, "k": 0 },
                    "o": { "a": 0, "k": 100 },
                    "pt": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [121, 0],
                                            [121, 62],
                                            [0, 62],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [121, 0],
                                            [121, 62],
                                            [0, 62],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 36
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [121, 0],
                                            [121, 62],
                                            [0, 62],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 54
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [121, 0],
                                            [121, 62],
                                            [0, 62],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 90
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [121, 0],
                                            [121, 62],
                                            [0, 62],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 108
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [121, 0],
                                            [121, 62],
                                            [0, 62],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 144
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [121, 0],
                                            [121, 62],
                                            [0, 62],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 162
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [121, 0],
                                            [121, 62],
                                            [0, 62],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 198
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [121, 0],
                                            [121, 62],
                                            [0, 62],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 216
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [121, 0],
                                            [121, 62],
                                            [0, 62],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 252
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 1, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [121, 0],
                                            [121, 62],
                                            [0, 62],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 270
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [121, 0],
                                            [121, 62],
                                            [0, 62],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 306
                            }
                        ]
                    }
                }
            ],
            "w": 400,
            "h": 180,
            "refId": "4",
            "ind": 4
        },
        {
            "ty": 0,
            "nm": "scribble 1",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": true,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [87.5, 21] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [116.5, 150] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 0
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 36
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [100],
                            "t": 54
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [100],
                            "t": 90
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 108
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 144
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 162
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 198
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 216
                        },
                        {
                            "o": { "x": 0.65, "y": 0 },
                            "i": { "x": 0.35, "y": 0 },
                            "s": [0],
                            "t": 252
                        },
                        {
                            "o": { "x": 0, "y": 0 },
                            "i": { "x": 1, "y": 1 },
                            "s": [0],
                            "t": 270
                        },
                        { "s": [0], "t": 306 }
                    ]
                }
            },
            "masksProperties": [
                {
                    "nm": "",
                    "inv": false,
                    "mode": "a",
                    "x": { "a": 0, "k": 0 },
                    "o": { "a": 0, "k": 100 },
                    "pt": {
                        "a": 1,
                        "k": [
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [175, 0],
                                            [175, 42],
                                            [0, 42],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 0
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [175, 0],
                                            [175, 42],
                                            [0, 42],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 36
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [175, 0],
                                            [175, 42],
                                            [0, 42],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 54
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [175, 0],
                                            [175, 42],
                                            [0, 42],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 90
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [175, 0],
                                            [175, 42],
                                            [0, 42],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 108
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [175, 0],
                                            [175, 42],
                                            [0, 42],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 144
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [175, 0],
                                            [175, 42],
                                            [0, 42],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 162
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [175, 0],
                                            [175, 42],
                                            [0, 42],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 198
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [175, 0],
                                            [175, 42],
                                            [0, 42],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 216
                            },
                            {
                                "o": { "x": 0.65, "y": 0 },
                                "i": { "x": 0.35, "y": 0 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [175, 0],
                                            [175, 42],
                                            [0, 42],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 252
                            },
                            {
                                "o": { "x": 0, "y": 0 },
                                "i": { "x": 1, "y": 1 },
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [175, 0],
                                            [175, 42],
                                            [0, 42],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 270
                            },
                            {
                                "s": [
                                    {
                                        "c": true,
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [175, 0],
                                            [175, 42],
                                            [0, 42],
                                            [0, 0]
                                        ]
                                    }
                                ],
                                "t": 306
                            }
                        ]
                    }
                }
            ],
            "w": 400,
            "h": 180,
            "refId": "5",
            "ind": 5
        },
        {
            "ty": 4,
            "nm": "Apps",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [129.29, 45.32] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [200.29, 100.32] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [],
            "ind": 6
        },
        {
            "ty": 4,
            "nm": "Intersects",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [64.72, 21.01] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [131.02, 44.42] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [],
            "ind": 7,
            "parent": 6
        },
        {
            "ty": 4,
            "nm": "Intersect 1",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [2.96, 15.96] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [2.96, 26.06] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, 0],
                                [4.03, -2.05],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0.69, 4.72],
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [5.81, 20.7],
                                [0, 31.92],
                                [2.8, 0],
                                [5.81, 20.7]
                            ]
                        }
                    }
                },
                {
                    "ty": "fl",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "c": { "a": 0, "k": [0.0353, 0.1961, 0.4236] },
                    "r": 1,
                    "o": { "a": 0, "k": 100 }
                }
            ],
            "ind": 8,
            "parent": 7
        },
        {
            "ty": 4,
            "nm": "Intersect 2",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [2.82, 18.12] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [65, 20.93] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, 0],
                                [0.39, -4.42],
                                [0, 0],
                                [0.1, 1.3],
                                [0, 0]
                            ],
                            "o": [
                                [3.66, 2],
                                [0, 0],
                                [-0.5, -1.12],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [0, 0],
                                [5.6, 10.46],
                                [3.34, 36.25],
                                [2.42, 32.6],
                                [0, 0]
                            ]
                        }
                    }
                },
                {
                    "ty": "fl",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "c": { "a": 0, "k": [0.0353, 0.1961, 0.4236] },
                    "r": 1,
                    "o": { "a": 0, "k": 100 }
                }
            ],
            "ind": 9,
            "parent": 7
        },
        {
            "ty": 4,
            "nm": "Intersect 3",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [1.95, 19.87] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [127.49, 19.87] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, 0],
                                [2.59, -2.16],
                                [0, 0],
                                [-0.12, 0.58],
                                [0, 0]
                            ],
                            "o": [
                                [0.27, 3.62],
                                [0, 0],
                                [0.02, -0.61],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [3.87, 30.61],
                                [0, 39.73],
                                [1.38, 1.78],
                                [1.6, 0],
                                [3.87, 30.61]
                            ]
                        }
                    }
                },
                {
                    "ty": "fl",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "c": { "a": 0, "k": [0.0353, 0.1961, 0.4236] },
                    "r": 1,
                    "o": { "a": 0, "k": 100 }
                }
            ],
            "ind": 10,
            "parent": 7
        },
        {
            "ty": 4,
            "nm": "Rovo",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [32.5, 32.5] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [224.91, 48.02] },
                "r": { "a": 0, "k": 2.09 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [],
            "ind": 11,
            "parent": 6
        },
        {
            "ty": 4,
            "nm": "Vector",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [17.01, 18.68] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [32, 32.41] },
                "r": { "a": 0, "k": -2.09 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, 0],
                                [-1.26, -0.79],
                                [0, 0],
                                [0.06, -1.51],
                                [0, 0],
                                [1.34, -0.71],
                                [0, 0],
                                [-0.02, 0.06],
                                [-0.02, 0.58],
                                [0, 0],
                                [1.69, 1.05],
                                [0, 0],
                                [0, 0],
                                [-0.14, 0.4],
                                [-0.94, 0.5],
                                [0, 0],
                                [-0.02, 0.02]
                            ],
                            "o": [
                                [1.32, -0.67],
                                [0, 0],
                                [1.28, 0.8],
                                [0, 0],
                                [-0.06, 1.52],
                                [0, 0],
                                [0.02, -0.06],
                                [0.19, -0.53],
                                [0, 0],
                                [0.07, -1.98],
                                [0, 0],
                                [0, 0],
                                [0.02, -0.44],
                                [0.35, -0.98],
                                [0, 0],
                                [0.03, -0.01],
                                [0, 0]
                            ],
                            "v": [
                                [15.63, 0.45],
                                [19.8, 0.65],
                                [32.04, 8.32],
                                [34.02, 12.07],
                                [33.5, 26.51],
                                [31.24, 30.1],
                                [21.64, 35.18],
                                [21.71, 35.01],
                                [22.04, 33.32],
                                [22.57, 18.88],
                                [19.97, 13.98],
                                [13.1, 9.67],
                                [13.31, 4.08],
                                [13.55, 2.81],
                                [15.55, 0.5],
                                [15.56, 0.5],
                                [15.63, 0.45]
                            ]
                        }
                    }
                },
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0.06, -1.52],
                                [0, 0],
                                [-1.28, -0.8],
                                [0, 0],
                                [-1.32, 0.67],
                                [-0.03, 0.01],
                                [-0.35, 0.98],
                                [-0.02, 0.44],
                                [0, 0],
                                [0, 0],
                                [-0.07, 1.98],
                                [0, 0],
                                [-0.19, 0.53],
                                [-0.02, 0.06]
                            ],
                            "o": [
                                [0, 0],
                                [-1.34, 0.71],
                                [0, 0],
                                [-0.06, 1.51],
                                [0, 0],
                                [1.26, 0.79],
                                [0.02, -0.02],
                                [0.94, -0.5],
                                [0.14, -0.4],
                                [0, 0],
                                [0, 0],
                                [-1.68, -1.05],
                                [0, 0],
                                [0.02, -0.58],
                                [0.02, -0.06],
                                [0, 0]
                            ],
                            "v": [
                                [12.38, 2.19],
                                [2.78, 7.27],
                                [0.53, 10.86],
                                [0, 25.3],
                                [1.99, 29.04],
                                [14.23, 36.72],
                                [18.39, 36.91],
                                [18.47, 36.87],
                                [20.47, 34.56],
                                [20.72, 33.29],
                                [20.92, 27.69],
                                [14.06, 23.39],
                                [11.46, 18.49],
                                [11.99, 4.05],
                                [12.32, 2.36],
                                [12.38, 2.19]
                            ]
                        }
                    }
                },
                {
                    "ty": "fl",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "c": { "a": 0, "k": [1, 1, 1] },
                    "r": 1,
                    "o": { "a": 0, "k": 100 }
                }
            ],
            "ind": 12,
            "parent": 11
        },
        {
            "ty": 4,
            "nm": "App Tile 1",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [32.5, 32.5] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [32.5, 32.5] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, -5.98],
                                [0, 0],
                                [5.98, 0],
                                [0, 0],
                                [0, 5.98],
                                [0, 0],
                                [-5.98, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 5.98],
                                [0, 0],
                                [-5.98, 0],
                                [0, 0],
                                [0, -5.98],
                                [0, 0],
                                [5.98, 0]
                            ],
                            "v": [
                                [65, 10.83],
                                [65, 54.17],
                                [54.17, 65],
                                [10.83, 65],
                                [0, 54.17],
                                [0, 10.83],
                                [10.83, 0],
                                [54.17, 0]
                            ]
                        }
                    }
                },
                {
                    "ty": "fl",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "c": { "a": 0, "k": [0.0942, 0.4079, 0.8589] },
                    "r": 1,
                    "o": { "a": 0, "k": 100 }
                }
            ],
            "ind": 13,
            "parent": 11
        },
        {
            "ty": 4,
            "nm": "Loom",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [32.5, 32.5] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [161.71, 34.81] },
                "r": { "a": 0, "k": -4.24 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [],
            "ind": 14,
            "parent": 6
        },
        {
            "ty": 4,
            "nm": "Vector",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [20.25, 20.25] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [32.5, 32.5] },
                "r": { "a": 0, "k": 4.24 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [40.18, 16.53],
                                [28.43, 17.4],
                                [38.17, 10.77],
                                [35.65, 7.07],
                                [25.91, 13.7],
                                [31.03, 3.09],
                                [26.99, 1.14],
                                [21.87, 11.75],
                                [21, 0],
                                [16.53, 0.33],
                                [17.4, 12.08],
                                [10.77, 2.34],
                                [7.07, 4.86],
                                [13.7, 14.6],
                                [3.09, 9.48],
                                [1.14, 13.52],
                                [11.75, 18.64],
                                [0, 19.51],
                                [0.33, 23.98],
                                [12.08, 23.11],
                                [2.34, 29.73],
                                [4.86, 33.44],
                                [14.6, 26.81],
                                [9.48, 37.42],
                                [13.52, 39.37],
                                [18.64, 28.76],
                                [19.51, 40.51],
                                [23.98, 40.18],
                                [23.11, 28.43],
                                [29.73, 38.17],
                                [33.44, 35.65],
                                [26.81, 25.91],
                                [37.42, 31.03],
                                [39.37, 26.99],
                                [28.76, 21.87],
                                [40.51, 21],
                                [40.17, 16.53],
                                [40.18, 16.53]
                            ]
                        }
                    }
                },
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, 0],
                                [0.25, 3.37],
                                [-3.37, 0.25],
                                [-0.25, -3.37],
                                [3.37, -0.25]
                            ],
                            "o": [
                                [-3.37, 0.25],
                                [-0.25, -3.37],
                                [3.37, -0.25],
                                [0.25, 3.37],
                                [0, 0]
                            ],
                            "v": [
                                [20.7, 26.33],
                                [14.15, 20.68],
                                [19.8, 14.13],
                                [26.35, 19.78],
                                [20.7, 26.33]
                            ]
                        }
                    }
                },
                {
                    "ty": "fl",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "c": { "a": 0, "k": [1, 1, 1] },
                    "r": 1,
                    "o": { "a": 0, "k": 100 }
                }
            ],
            "ind": 15,
            "parent": 14
        },
        {
            "ty": 4,
            "nm": "App Tile 2",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [32.5, 32.5] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [32.5, 32.5] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, -5.98],
                                [0, 0],
                                [5.98, 0],
                                [0, 0],
                                [0, 5.98],
                                [0, 0],
                                [-5.98, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 5.98],
                                [0, 0],
                                [-5.98, 0],
                                [0, 0],
                                [0, -5.98],
                                [0, 0],
                                [5.98, 0]
                            ],
                            "v": [
                                [65, 10.83],
                                [65, 54.17],
                                [54.17, 65],
                                [10.83, 65],
                                [0, 54.17],
                                [0, 10.83],
                                [10.83, 0],
                                [54.17, 0]
                            ]
                        }
                    }
                },
                {
                    "ty": "fl",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "c": { "a": 0, "k": [0.0942, 0.4079, 0.8589] },
                    "r": 1,
                    "o": { "a": 0, "k": 100 }
                }
            ],
            "ind": 16,
            "parent": 14
        },
        {
            "ty": 4,
            "nm": "Confluence",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [32.5, 32.5] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [99.81, 55.42] },
                "r": { "a": 0, "k": 5.02 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [],
            "ind": 17,
            "parent": 6
        },
        {
            "ty": 4,
            "nm": "Vector",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [19.24, 17.86] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [33, 33.01] },
                "r": { "a": 0, "k": -5.02 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, 0],
                                [4.59, 0.4],
                                [4.65, -5.94],
                                [0, 0],
                                [0.03, -0.36],
                                [-0.64, -0.48],
                                [0, 0],
                                [-0.31, -0.03],
                                [-0.42, 0.51],
                                [0, 0],
                                [-1.96, -0.17],
                                [-2.4, -1.43],
                                [0, 0],
                                [-0.44, 0.82],
                                [0, 0],
                                [0.82, 0.5]
                            ],
                            "o": [
                                [-10.43, -6.23],
                                [-5.39, -0.47],
                                [0, 0],
                                [-0.63, 0.8],
                                [-0.03, 0.36],
                                [0, 0],
                                [0.35, 0.27],
                                [0.37, 0.03],
                                [0, 0],
                                [1.94, -2.45],
                                [1.71, 0.15],
                                [0, 0],
                                [0.7, 0.43],
                                [0, 0],
                                [0.44, -0.82],
                                [0, 0]
                            ],
                            "v": [
                                [34.54, 25.89],
                                [16.4, 18.19],
                                [1.57, 25.49],
                                [0.81, 26.46],
                                [0, 27.92],
                                [0.77, 29.08],
                                [7.3, 33.99],
                                [8.25, 34.44],
                                [9.3, 33.8],
                                [10.55, 32.2],
                                [16.05, 29.21],
                                [22.15, 31.45],
                                [29.07, 35.48],
                                [31.03, 34.98],
                                [35.12, 27.77],
                                [34.54, 25.89]
                            ]
                        }
                    }
                },
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, 0],
                                [-4.59, -0.4],
                                [-4.65, 5.94],
                                [0, 0],
                                [-0.03, 0.36],
                                [0.64, 0.48],
                                [0, 0],
                                [0.31, 0.03],
                                [0.42, -0.51],
                                [0, 0],
                                [1.96, 0.17],
                                [2.4, 1.43],
                                [0, 0],
                                [0.44, -0.82],
                                [0, 0],
                                [-0.82, -0.5]
                            ],
                            "o": [
                                [10.43, 6.23],
                                [5.39, 0.47],
                                [0, 0],
                                [0.63, -0.8],
                                [0.03, -0.36],
                                [0, 0],
                                [-0.35, -0.27],
                                [-0.37, -0.03],
                                [0, 0],
                                [-1.94, 2.45],
                                [-1.71, -0.15],
                                [0, 0],
                                [-0.7, -0.43],
                                [0, 0],
                                [-0.44, 0.82],
                                [0, 0]
                            ],
                            "v": [
                                [3.94, 9.83],
                                [22.07, 17.53],
                                [36.9, 10.23],
                                [37.67, 9.26],
                                [38.47, 7.8],
                                [37.71, 6.64],
                                [31.17, 1.73],
                                [30.22, 1.28],
                                [29.18, 1.92],
                                [27.93, 3.52],
                                [22.42, 6.51],
                                [16.33, 4.27],
                                [9.4, 0.25],
                                [7.45, 0.74],
                                [3.36, 7.95],
                                [3.94, 9.83]
                            ]
                        }
                    }
                },
                {
                    "ty": "fl",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "c": { "a": 0, "k": [1, 1, 1] },
                    "r": 1,
                    "o": { "a": 0, "k": 100 }
                }
            ],
            "ind": 18,
            "parent": 17
        },
        {
            "ty": 4,
            "nm": "App Tile 3",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [32.5, 32.5] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [32.5, 32.5] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, -5.98],
                                [0, 0],
                                [5.98, 0],
                                [0, 0],
                                [0, 5.98],
                                [0, 0],
                                [-5.98, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 5.98],
                                [0, 0],
                                [-5.98, 0],
                                [0, 0],
                                [0, -5.98],
                                [0, 0],
                                [5.98, 0]
                            ],
                            "v": [
                                [65, 10.83],
                                [65, 54.17],
                                [54.17, 65],
                                [10.83, 65],
                                [0, 54.17],
                                [0, 10.83],
                                [10.83, 0],
                                [54.17, 0]
                            ]
                        }
                    }
                },
                {
                    "ty": "fl",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "c": { "a": 0, "k": [0.0942, 0.4079, 0.8589] },
                    "r": 1,
                    "o": { "a": 0, "k": 100 }
                }
            ],
            "ind": 19,
            "parent": 17
        },
        {
            "ty": 4,
            "nm": "Jira",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [32.5, 32.5] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [36.84, 37.45] },
                "r": { "a": 0, "k": -8.27 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [],
            "ind": 20,
            "parent": 6
        },
        {
            "ty": 4,
            "nm": "Vector",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [18.8, 20.06] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [31.85, 33.24] },
                "r": { "a": 0, "k": 8.27 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0.66, 4.53],
                                [0, 0],
                                [-0.14, -0.94],
                                [0, 0],
                                [0.74, 5.08],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [-5.05, 0.73],
                                [0, 0],
                                [0.93, -0.14],
                                [0, 0],
                                [-4.5, 0.65],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [13.12, 29.03],
                                [9.77, 29.52],
                                [0, 23.16],
                                [17.99, 20.55],
                                [19.76, 21.92],
                                [22.39, 40.03],
                                [13.61, 32.4],
                                [13.12, 29.03]
                            ]
                        }
                    }
                },
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0.66, 4.53],
                                [0, 0],
                                [-0.14, -0.94],
                                [0, 0],
                                [0.74, 5.08],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [-5.05, 0.73],
                                [0, 0],
                                [0.93, -0.14],
                                [0, 0],
                                [-4.5, 0.65],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [20.7, 18.74],
                                [17.35, 19.23],
                                [7.59, 12.93],
                                [25.58, 10.31],
                                [27.39, 11.63],
                                [30.02, 29.73],
                                [21.19, 22.11],
                                [20.7, 18.74]
                            ]
                        }
                    }
                },
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, 0],
                                [0, 0],
                                [0.66, 4.53],
                                [0, 0],
                                [-0.13, -0.88],
                                [0, 0],
                                [0.74, 5.08],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [-5.05, 0.73],
                                [0, 0],
                                [0.93, -0.14],
                                [0, 0],
                                [-4.5, 0.65],
                                [0, 0],
                                [0, 0]
                            ],
                            "v": [
                                [28.34, 8.5],
                                [24.99, 8.99],
                                [15.22, 2.63],
                                [33.21, 0.02],
                                [34.97, 1.34],
                                [37.6, 19.44],
                                [28.82, 11.82],
                                [28.34, 8.5]
                            ]
                        }
                    }
                },
                {
                    "ty": "fl",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "c": { "a": 0, "k": [1, 1, 1] },
                    "r": 1,
                    "o": { "a": 0, "k": 100 }
                }
            ],
            "ind": 21,
            "parent": 20
        },
        {
            "ty": 4,
            "nm": "App Tile 4",
            "sr": 1,
            "st": 0,
            "op": 271,
            "ip": 0,
            "hd": false,
            "ddd": 0,
            "bm": 0,
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": { "a": 0, "k": [32.5, 32.5] },
                "s": { "a": 0, "k": [100, 100] },
                "sk": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [32.5, 32.5] },
                "r": { "a": 0, "k": 0 },
                "sa": { "a": 0, "k": 0 },
                "o": { "a": 0, "k": 100 }
            },
            "shapes": [
                {
                    "ty": "sh",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "d": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "c": true,
                            "i": [
                                [0, -5.98],
                                [0, 0],
                                [5.98, 0],
                                [0, 0],
                                [0, 5.98],
                                [0, 0],
                                [-5.98, 0],
                                [0, 0]
                            ],
                            "o": [
                                [0, 0],
                                [0, 5.98],
                                [0, 0],
                                [-5.98, 0],
                                [0, 0],
                                [0, -5.98],
                                [0, 0],
                                [5.98, 0]
                            ],
                            "v": [
                                [65, 10.83],
                                [65, 54.17],
                                [54.17, 65],
                                [10.83, 65],
                                [0, 54.17],
                                [0, 10.83],
                                [10.83, 0],
                                [54.17, 0]
                            ]
                        }
                    }
                },
                {
                    "ty": "fl",
                    "bm": 0,
                    "hd": false,
                    "nm": "",
                    "c": { "a": 0, "k": [0.0942, 0.4079, 0.8589] },
                    "r": 1,
                    "o": { "a": 0, "k": 100 }
                }
            ],
            "ind": 22,
            "parent": 20
        }
    ],
    "v": "5.7.0",
    "fr": 60,
    "op": 270,
    "ip": 0,
    "assets": [
        {
            "nm": "[Asset] Swirl 1",
            "id": "1",
            "layers": [
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [44.12, 14.09] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [44.51, 14.66] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [-0.3, 0.2],
                                        [-0.16, 0.22],
                                        [0.16, 0.34],
                                        [0.48, 0.12],
                                        [0.3, -0.01],
                                        [0.39, -0.09],
                                        [2.66, 0],
                                        [3.23, 0.39],
                                        [1.98, 0.33],
                                        [2.3, 0.95],
                                        [1.89, 1.51],
                                        [0.42, 1.89],
                                        [-0.82, 1.46],
                                        [-0.19, 0.32],
                                        [-0.11, 0.15],
                                        [-0.06, 0.07],
                                        [-0.02, 0.02],
                                        [-0.01, -0.02],
                                        [-0.24, 0.02],
                                        [-0.17, -0.01],
                                        [-0.91, -0.85],
                                        [-0.25, -0.96],
                                        [0.26, -1.21],
                                        [0.81, -1],
                                        [1.28, -0.38],
                                        [0, 0],
                                        [0.19, -0.04],
                                        [0, 0],
                                        [0.42, -0.04],
                                        [0, 0],
                                        [0.85, 0.05],
                                        [0.84, 0.12],
                                        [2.95, 0.92],
                                        [1.44, 0.65],
                                        [2.7, 1.42],
                                        [2.45, 1.35],
                                        [-2.43, -2.01],
                                        [-2.67, -1.69],
                                        [-3.61, -1.61],
                                        [-1.07, -0.5],
                                        [-1.46, -0.59],
                                        [-4.66, -0.57],
                                        [-0.76, -0.05],
                                        [-0.76, 0.03],
                                        [-0.41, 0.04],
                                        [-0.42, 0.05],
                                        [-0.85, 0.18],
                                        [-0.85, 0.16],
                                        [-0.47, 0.13],
                                        [-0.44, 0.25],
                                        [-0.75, 0.62],
                                        [-0.51, 0.77],
                                        [-0.34, 1.59],
                                        [1.16, 1.86],
                                        [0.27, 0.34],
                                        [0.24, 0.2],
                                        [0.13, 0.1],
                                        [0, 0],
                                        [0.2, 0.13],
                                        [0.43, 0.15],
                                        [1.48, -0.03],
                                        [0.41, -0.02],
                                        [0.58, -0.1],
                                        [0.4, -0.5],
                                        [0.3, -0.43],
                                        [0.23, -0.41],
                                        [0.19, -0.45],
                                        [0.15, -1.1],
                                        [-1.02, -2.05],
                                        [-1.57, -1.26],
                                        [-1.54, -0.76],
                                        [-0.7, -0.3],
                                        [-0.61, -0.24],
                                        [-2.17, -0.42],
                                        [-1.15, -0.14],
                                        [-2.89, 0.21],
                                        [-2.52, 0.93],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0.44, -0.17],
                                        [0.3, -0.22],
                                        [0.32, -0.45],
                                        [-0.16, -0.34],
                                        [-0.25, -0.06],
                                        [-0.32, -0.01],
                                        [-2.25, 0.44],
                                        [-2.66, 0],
                                        [-3.67, -0.39],
                                        [-1.97, -0.39],
                                        [-1.93, -0.8],
                                        [-1.93, -1.48],
                                        [-0.38, -1.91],
                                        [0.22, -0.36],
                                        [0.12, -0.15],
                                        [0.06, -0.07],
                                        [0.07, -0.11],
                                        [0.03, 0.01],
                                        [-0.01, 0.01],
                                        [0.19, -0.02],
                                        [0.63, -0.01],
                                        [0.47, 0.41],
                                        [0.24, 0.96],
                                        [-0.24, 1.21],
                                        [-0.81, 1],
                                        [0, 0],
                                        [-0.15, 0.05],
                                        [0, 0],
                                        [-0.42, 0.06],
                                        [0, 0],
                                        [-0.85, 0.05],
                                        [-0.85, -0.05],
                                        [-4.75, -0.37],
                                        [-2.94, -0.99],
                                        [-3.42, -1.49],
                                        [-2.71, -1.4],
                                        [-2.68, -1.5],
                                        [2.22, 1.8],
                                        [2.66, 1.7],
                                        [0.7, 0.32],
                                        [1.06, 0.52],
                                        [2.93, 1.13],
                                        [0.76, 0.08],
                                        [0.76, 0],
                                        [0.41, -0.02],
                                        [0.42, -0.05],
                                        [0.84, -0.12],
                                        [0.84, -0.17],
                                        [0.42, -0.07],
                                        [0.47, -0.19],
                                        [0.91, -0.42],
                                        [0.71, -0.66],
                                        [1.08, -1.52],
                                        [0.66, -3.2],
                                        [-0.27, -0.48],
                                        [-0.3, -0.32],
                                        [-0.24, -0.19],
                                        [-0.13, -0.1],
                                        [0, 0],
                                        [-0.21, -0.11],
                                        [-0.82, -0.37],
                                        [-0.38, -0.02],
                                        [-0.5, 0.03],
                                        [-0.7, -0.05],
                                        [-0.28, 0.41],
                                        [-0.26, 0.34],
                                        [-0.21, 0.41],
                                        [-0.34, 0.93],
                                        [-0.4, 2.13],
                                        [1, 2.07],
                                        [1.57, 1.27],
                                        [0.76, 0.41],
                                        [0.7, 0.33],
                                        [3.71, 1.37],
                                        [2.16, 0.42],
                                        [3.47, 0.4],
                                        [2.89, -0.23],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [86.14, 26.41],
                                        [87.25, 25.84],
                                        [87.94, 25.16],
                                        [88.15, 23.95],
                                        [87.15, 23.24],
                                        [86.32, 23.17],
                                        [85.24, 23.29],
                                        [77.89, 23.89],
                                        [69.11, 23.33],
                                        [61.18, 22.24],
                                        [55.22, 20.54],
                                        [49.2, 17.1],
                                        [45.45, 11.72],
                                        [46.52, 6.51],
                                        [47.13, 5.48],
                                        [47.48, 5.03],
                                        [47.65, 4.82],
                                        [47.7, 4.77],
                                        [47.78, 4.83],
                                        [48.03, 4.84],
                                        [48.57, 4.81],
                                        [51.19, 5.67],
                                        [52.34, 7.77],
                                        [52.37, 11.13],
                                        [50.77, 14.56],
                                        [47.57, 16.68],
                                        [47.07, 16.81],
                                        [46.47, 16.91],
                                        [45.21, 17.1],
                                        [43.94, 17.28],
                                        [42.66, 17.35],
                                        [40.1, 17.42],
                                        [37.57, 17.3],
                                        [26.07, 14.97],
                                        [19.56, 12.46],
                                        [10.51, 8.06],
                                        [2.88, 3.94],
                                        [1.26, 6.33],
                                        [8.47, 11.57],
                                        [17.74, 16.58],
                                        [20.39, 17.8],
                                        [24.19, 19.44],
                                        [35.54, 22.4],
                                        [37.83, 22.6],
                                        [40.11, 22.54],
                                        [41.35, 22.47],
                                        [42.6, 22.33],
                                        [45.13, 21.99],
                                        [47.67, 21.5],
                                        [49.09, 21.12],
                                        [50.48, 20.53],
                                        [52.95, 18.89],
                                        [54.83, 16.75],
                                        [56.86, 11.96],
                                        [55.68, 3.9],
                                        [54.81, 2.69],
                                        [54, 1.9],
                                        [53.44, 1.46],
                                        [53.23, 1.31],
                                        [52.91, 1.13],
                                        [51.98, 0.66],
                                        [48.41, 0],
                                        [47.26, 0.08],
                                        [45.57, 0.37],
                                        [44.24, 1.51],
                                        [43.36, 2.78],
                                        [42.68, 3.96],
                                        [42.04, 5.23],
                                        [41.16, 8.2],
                                        [42.07, 14.85],
                                        [46.14, 19.81],
                                        [50.87, 22.84],
                                        [53.07, 23.88],
                                        [55.05, 24.67],
                                        [63.76, 27.07],
                                        [68.58, 27.82],
                                        [78.06, 28.06],
                                        [86.13, 26.43],
                                        [86.14, 26.41]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Swirl 1 Bg",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [44.5, 14.5] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [44.5, 14.5] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 0
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 36
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 54
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 90
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [100],
                                    "t": 108
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [100],
                                    "t": 144
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 162
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 198
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 216
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 252
                                },
                                {
                                    "o": { "x": 0, "y": 0 },
                                    "i": { "x": 1, "y": 1 },
                                    "s": [0],
                                    "t": 270
                                },
                                { "s": [0], "t": 306 }
                            ]
                        }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [89, 0],
                                        [89, 29],
                                        [0, 29],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [1, 1, 1] },
                            "r": 1,
                            "o": { "a": 0, "k": 0 }
                        }
                    ],
                    "ind": 2
                }
            ]
        },
        {
            "nm": "[Asset] check 1",
            "id": "2",
            "layers": [
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [24.22, 23.73] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [24.6, 24.22] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [-0.13, -0.15],
                                        [-0.12, -0.13],
                                        [-0.2, -0.16],
                                        [-0.21, 0.1],
                                        [0.09, 0.52],
                                        [0.13, 0.36],
                                        [0.1, 0.2],
                                        [0.13, 0.21],
                                        [2.62, 1.84],
                                        [3.91, 0.53],
                                        [1.54, -0.32],
                                        [0.35, -0.12],
                                        [0.32, -0.1],
                                        [0.56, -0.24],
                                        [2.13, -2.04],
                                        [0.46, -0.49],
                                        [0.41, -0.58],
                                        [0.69, -1.35],
                                        [0.49, -1.45],
                                        [0.25, -1.45],
                                        [-0.28, -2.31],
                                        [-0.36, -0.98],
                                        [-0.12, -0.28],
                                        [0, 0],
                                        [-1.91, -1.95],
                                        [-1.4, -0.87],
                                        [-1.74, -0.61],
                                        [-4.1, 0.52],
                                        [-1.94, 0.69],
                                        [-0.48, 0.19],
                                        [-0.46, 0.24],
                                        [-0.46, 0.23],
                                        [-0.45, 0.25],
                                        [-1.48, 1.85],
                                        [-0.75, 1.7],
                                        [-0.17, 1.84],
                                        [0.23, 1.92],
                                        [0.53, 1.67],
                                        [2.25, 2.39],
                                        [0.27, 0.2],
                                        [0.22, 0.08],
                                        [0.13, -0.16],
                                        [-0.2, -0.38],
                                        [-0.16, -0.26],
                                        [-0.22, -0.33],
                                        [-0.82, -3.11],
                                        [-0.16, -1.77],
                                        [0.18, -1.97],
                                        [1.23, -2.8],
                                        [1.15, -1.47],
                                        [1.79, -1.27],
                                        [1.26, -0.69],
                                        [0.73, -0.34],
                                        [0.79, -0.23],
                                        [1.63, -0.14],
                                        [0.81, 0],
                                        [0.77, 0.12],
                                        [1.32, 0.49],
                                        [1.25, 1.13],
                                        [0.24, 0.23],
                                        [0.16, 0.17],
                                        [0.07, 0.09],
                                        [0, 0],
                                        [0.1, 0.14],
                                        [0.19, 0.27],
                                        [0.25, 0.41],
                                        [0.25, 0.55],
                                        [0, 3.7],
                                        [-0.4, 1.9],
                                        [-0.78, 1.69],
                                        [-0.99, 1.3],
                                        [-0.96, 0.83],
                                        [-1.29, 0.6],
                                        [-0.3, 0.13],
                                        [-0.29, 0.09],
                                        [-0.28, 0.07],
                                        [-0.26, 0.05],
                                        [-1.11, -0.16],
                                        [-2.39, -1.52],
                                        [-1.56, -2.06],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0.14, 0.18],
                                        [0.13, 0.16],
                                        [0.23, 0.26],
                                        [0.39, 0.31],
                                        [0.21, -0.11],
                                        [-0.04, -0.26],
                                        [-0.07, -0.17],
                                        [-0.1, -0.19],
                                        [-1.5, -2.41],
                                        [-2.61, -1.82],
                                        [-2.21, -0.26],
                                        [-0.39, 0.09],
                                        [-0.35, 0.11],
                                        [-0.66, 0.17],
                                        [-2.17, 1.09],
                                        [-0.46, 0.43],
                                        [-0.42, 0.52],
                                        [-0.84, 1.14],
                                        [-0.69, 1.34],
                                        [-0.5, 1.46],
                                        [-0.51, 2.92],
                                        [0.28, 2.33],
                                        [0.11, 0.29],
                                        [0, 0],
                                        [0.51, 0.97],
                                        [0.97, 0.96],
                                        [1.39, 0.88],
                                        [3.48, 1.24],
                                        [2.05, -0.25],
                                        [0.49, -0.15],
                                        [0.48, -0.2],
                                        [0.46, -0.23],
                                        [0.47, -0.22],
                                        [2.46, -1.53],
                                        [1.49, -1.86],
                                        [1.41, -3.44],
                                        [0.2, -2.18],
                                        [-0.23, -1.92],
                                        [-1.07, -3.33],
                                        [-0.29, -0.34],
                                        [-0.27, -0.2],
                                        [-0.45, -0.16],
                                        [-0.12, 0.17],
                                        [0.11, 0.19],
                                        [0.16, 0.26],
                                        [1.76, 2.3],
                                        [0.41, 1.56],
                                        [0.16, 1.76],
                                        [-0.14, 1.53],
                                        [-0.63, 1.39],
                                        [-1.15, 1.46],
                                        [-1.15, 0.85],
                                        [-0.68, 0.36],
                                        [-0.76, 0.27],
                                        [-1.57, 0.5],
                                        [-0.82, 0.08],
                                        [-0.8, -0.04],
                                        [-1.55, -0.22],
                                        [-2.63, -0.96],
                                        [-0.31, -0.29],
                                        [-0.22, -0.24],
                                        [-0.15, -0.17],
                                        [-0.07, -0.09],
                                        [0, 0],
                                        [-0.11, -0.14],
                                        [-0.18, -0.28],
                                        [-0.23, -0.41],
                                        [-1.1, -2.12],
                                        [0, -1.84],
                                        [0.41, -1.88],
                                        [0.78, -1.69],
                                        [0.99, -1.31],
                                        [1.45, -1.24],
                                        [0.32, -0.13],
                                        [0.3, -0.14],
                                        [0.3, -0.08],
                                        [0.28, -0.04],
                                        [2.1, -0.3],
                                        [3.39, 0.45],
                                        [2.4, 1.54],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [37.9, 11.63],
                                        [38.32, 12.13],
                                        [38.67, 12.57],
                                        [39.3, 13.2],
                                        [40.23, 13.51],
                                        [40.44, 12.58],
                                        [40.18, 11.65],
                                        [39.94, 11.08],
                                        [39.58, 10.48],
                                        [33.44, 4.02],
                                        [23.71, 0.15],
                                        [18.11, 0.3],
                                        [17, 0.54],
                                        [15.99, 0.85],
                                        [14.2, 1.59],
                                        [8.24, 5.92],
                                        [6.91, 7.33],
                                        [5.62, 8.95],
                                        [3.3, 12.68],
                                        [1.51, 16.9],
                                        [0.42, 21.31],
                                        [0.19, 29.38],
                                        [1.41, 34.47],
                                        [1.75, 35.34],
                                        [2.16, 36.18],
                                        [5.61, 40.94],
                                        [9.13, 43.77],
                                        [13.85, 46.05],
                                        [25.56, 47.24],
                                        [31.6, 45.8],
                                        [33.05, 45.25],
                                        [34.48, 44.64],
                                        [35.86, 43.95],
                                        [37.2, 43.18],
                                        [43.11, 37.98],
                                        [46.37, 32.56],
                                        [48.33, 24.55],
                                        [48.23, 18.4],
                                        [47.07, 13.01],
                                        [42.25, 4.35],
                                        [41.36, 3.57],
                                        [40.59, 3.16],
                                        [39.73, 3.2],
                                        [39.86, 4.04],
                                        [40.27, 4.69],
                                        [40.89, 5.53],
                                        [44.64, 13.71],
                                        [45.52, 18.69],
                                        [45.54, 24.29],
                                        [43.74, 30.99],
                                        [41.14, 35.34],
                                        [36.75, 39.5],
                                        [33.1, 41.75],
                                        [30.94, 42.76],
                                        [28.63, 43.57],
                                        [23.79, 44.49],
                                        [21.35, 44.57],
                                        [18.98, 44.36],
                                        [14.65, 43.31],
                                        [8.73, 39.86],
                                        [7.9, 39.08],
                                        [7.33, 38.46],
                                        [6.99, 38.06],
                                        [6.88, 37.92],
                                        [6.71, 37.71],
                                        [6.24, 37.1],
                                        [5.57, 36.08],
                                        [4.79, 34.66],
                                        [2.78, 25.55],
                                        [3.38, 19.88],
                                        [5.21, 14.45],
                                        [7.94, 9.91],
                                        [10.95, 6.7],
                                        [15.12, 3.98],
                                        [16.06, 3.59],
                                        [16.97, 3.31],
                                        [17.82, 3.08],
                                        [18.63, 2.95],
                                        [23.33, 2.92],
                                        [32, 6.16],
                                        [37.91, 11.61],
                                        [37.9, 11.63]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [7.59, 6.96] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [24.27, 26.24] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [-0.3, -0.45],
                                        [-0.69, -0.69],
                                        [-0.27, -0.16],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-0.09, -0.1],
                                        [-0.2, -0.29],
                                        [-0.55, -0.86],
                                        [-0.5, 0.69],
                                        [-0.24, 0.29],
                                        [-0.06, 0.06],
                                        [-0.03, 0.04],
                                        [-0.04, 0.07],
                                        [-1.54, 1.52],
                                        [-0.35, 0.34],
                                        [-0.45, 0.8],
                                        [0.49, -0.18],
                                        [0.9, -0.85],
                                        [1.02, -1.01],
                                        [0.1, -0.22],
                                        [0.51, -0.73],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0.08, -0.11],
                                        [0.09, 0.11],
                                        [0.05, 0.05],
                                        [0.12, 0.13],
                                        [0.13, 0.13],
                                        [0.8, 0.3],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [-0.57, -0.21],
                                        [0.44, 0.64],
                                        [0.42, 0.36],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0.1, 0.08],
                                        [0.19, 0.19],
                                        [0.41, 0.55],
                                        [0.57, -0.78],
                                        [0.28, -0.38],
                                        [0.14, -0.18],
                                        [0.05, -0.05],
                                        [0.06, -0.05],
                                        [0.25, -0.5],
                                        [1.01, -1.13],
                                        [0.83, -0.81],
                                        [0.25, -0.43],
                                        [-0.89, 0.33],
                                        [-0.35, 0.33],
                                        [-0.16, 0.17],
                                        [-0.45, 0.93],
                                        [-0.51, 0.72],
                                        [0, 0],
                                        [0, 0],
                                        [-0.09, 0.13],
                                        [-0.08, -0.12],
                                        [-0.06, -0.07],
                                        [-0.16, -0.18],
                                        [-0.24, -0.26],
                                        [-0.81, -0.78],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [1.28, 6.36],
                                        [0.06, 7.97],
                                        [1.68, 9.9],
                                        [2.69, 10.61],
                                        [2.74, 10.64],
                                        [2.81, 10.7],
                                        [2.97, 10.83],
                                        [3.26, 11.1],
                                        [3.84, 11.78],
                                        [5.28, 13.93],
                                        [6.95, 11.65],
                                        [7.74, 10.63],
                                        [7.97, 10.38],
                                        [8.1, 10.25],
                                        [8.24, 10.06],
                                        [11.28, 5.84],
                                        [13.32, 3.71],
                                        [15.13, 1.41],
                                        [13.98, 0.02],
                                        [11.37, 1.69],
                                        [9, 3.46],
                                        [8.59, 4.04],
                                        [6.99, 6.64],
                                        [6.08, 7.87],
                                        [5.55, 8.65],
                                        [5.3, 9.03],
                                        [5.04, 9.43],
                                        [4.78, 9.08],
                                        [4.61, 8.9],
                                        [4.19, 8.44],
                                        [3.64, 7.89],
                                        [1.27, 6.35],
                                        [1.28, 6.36]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "check 1 Bg",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [24.5, 24] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [24.5, 24] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [100],
                                    "t": 0
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [100],
                                    "t": 36
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 54
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 90
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 108
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 144
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 162
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 198
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 216
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 252
                                },
                                {
                                    "o": { "x": 0, "y": 0 },
                                    "i": { "x": 1, "y": 1 },
                                    "s": [100],
                                    "t": 270
                                },
                                { "s": [100], "t": 306 }
                            ]
                        }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [49, 0],
                                        [49, 48],
                                        [0, 48],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [1, 1, 1] },
                            "r": 1,
                            "o": { "a": 0, "k": 0 }
                        }
                    ],
                    "ind": 3
                }
            ]
        },
        {
            "nm": "[Asset] Burst 1",
            "id": "3",
            "layers": [
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [19.31, 5.83] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [19.69, 19.16] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [-0.92, -0.41],
                                        [-1.82, -0.39],
                                        [-1.39, -0.4],
                                        [-0.92, -0.47],
                                        [-0.15, -0.03],
                                        [-4.05, -1.09],
                                        [-0.97, -0.13],
                                        [-1.68, 0.48],
                                        [0.85, 0.3],
                                        [2.09, 0.31],
                                        [2.32, 0.63],
                                        [0.41, -0.01],
                                        [0, 0],
                                        [1.97, 0.58],
                                        [1.41, 0.36],
                                        [0.64, 0.13],
                                        [1.51, -0.22],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [-1.06, 0.14],
                                        [1.32, 0.56],
                                        [2.09, 0.31],
                                        [2.38, 0.61],
                                        [0.13, 0.07],
                                        [1.07, 0.19],
                                        [2.89, 0.65],
                                        [2.28, 0.29],
                                        [0.93, -0.26],
                                        [-1.55, -0.54],
                                        [-0.81, -0.11],
                                        [-0.38, -0.1],
                                        [-3.51, 0.08],
                                        [0, 0],
                                        [-1.97, -0.58],
                                        [-2.13, -0.53],
                                        [-1.94, -0.39],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0.96, 0.12],
                                        [0.56, 3.34],
                                        [5.07, 4.74],
                                        [9.2, 5.07],
                                        [16.32, 8.05],
                                        [16.75, 8.19],
                                        [26.51, 10.49],
                                        [32.22, 11.51],
                                        [37.94, 11.14],
                                        [37.97, 8.25],
                                        [32.8, 7.06],
                                        [28.08, 5.45],
                                        [26.9, 5.32],
                                        [19.11, 3.86],
                                        [15.52, 2.8],
                                        [9.79, 1.21],
                                        [5.97, 0.34],
                                        [0.94, 0.14],
                                        [0.96, 0.12]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [7.87, 19.06] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [21.08, 23.48] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0.46, -0.56],
                                        [-0.1, -0.35],
                                        [-0.22, -0.63],
                                        [-0.53, -1],
                                        [-0.59, -1.36],
                                        [-0.37, -1.44],
                                        [-0.08, -0.5],
                                        [-0.06, -0.13],
                                        [-0.62, -1.7],
                                        [-0.41, -2],
                                        [-0.22, -0.92],
                                        [-0.86, -1.49],
                                        [-0.07, 0.93],
                                        [0.48, 2.18],
                                        [0.53, 2.53],
                                        [0.2, 0.37],
                                        [0.53, 1.55],
                                        [0, 0],
                                        [0.79, 1.98],
                                        [0.66, 1.33],
                                        [0.31, 0.56],
                                        [1.44, 1.11],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [-0.53, -0.41],
                                        [-0.48, 0.57],
                                        [0.19, 0.57],
                                        [0.25, 0.7],
                                        [1.14, 1.85],
                                        [0.55, 1.12],
                                        [0.37, 1.44],
                                        [0.02, 0.15],
                                        [0.22, 0.48],
                                        [0.63, 1.7],
                                        [0.71, 2.79],
                                        [0.52, 2.16],
                                        [0.48, 0.82],
                                        [0.12, -1.7],
                                        [-0.2, -0.85],
                                        [-0.09, -0.42],
                                        [-0.88, -1.64],
                                        [-0.53, -1.54],
                                        [0, 0],
                                        [-0.79, -1.99],
                                        [-1, -2],
                                        [-0.82, -1.53],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [2.5, 0.18],
                                        [0.75, 0.68],
                                        [0.02, 2.25],
                                        [0.62, 4.05],
                                        [1.68, 6.53],
                                        [4.13, 9.97],
                                        [5.56, 14.13],
                                        [6.25, 17.36],
                                        [6.38, 17.79],
                                        [7.83, 21.26],
                                        [9.5, 27.05],
                                        [10.84, 32.51],
                                        [12.87, 37.72],
                                        [15.68, 37.06],
                                        [15.22, 31.49],
                                        [14.72, 26.19],
                                        [14.28, 25.01],
                                        [12.15, 19.87],
                                        [11.29, 17.19],
                                        [9.94, 13.53],
                                        [7.45, 7.93],
                                        [5.62, 4.4],
                                        [2.49, 0.18],
                                        [2.5, 0.18]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [7.44, 19.63] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [20.01, 20] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0.52, -0.84],
                                        [0.71, -1.9],
                                        [0.5, -1.49],
                                        [0.42, -0.96],
                                        [0.03, -0.15],
                                        [0.39, -1.79],
                                        [0.31, -0.96],
                                        [0.37, -0.97],
                                        [0.33, -0.87],
                                        [0.29, -1.63],
                                        [-0.71, 0.72],
                                        [-0.84, 2.18],
                                        [-0.91, 2.44],
                                        [-0.03, 0.43],
                                        [-0.37, 1.61],
                                        [0, 0],
                                        [-0.5, 2.07],
                                        [-0.41, 1.37],
                                        [-0.22, 0.63],
                                        [-0.04, 1.6],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0.02, -1.15],
                                        [-0.76, 1.22],
                                        [-0.66, 2.22],
                                        [-0.74, 2.56],
                                        [-0.06, 0.14],
                                        [-0.08, 0.55],
                                        [-0.2, 0.89],
                                        [-0.31, 0.98],
                                        [-0.92, 2.84],
                                        [-0.75, 2.06],
                                        [-0.16, 0.88],
                                        [1.27, -1.29],
                                        [0.32, -0.84],
                                        [0.15, -0.4],
                                        [0.13, -1.78],
                                        [0.4, -1.63],
                                        [0, 0],
                                        [0.49, -2.06],
                                        [0.6, -2.06],
                                        [0.66, -1.86],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [14.87, 1.29],
                                        [11.75, 0.4],
                                        [9.58, 4.83],
                                        [8.77, 9.3],
                                        [5.92, 16.95],
                                        [5.79, 17.39],
                                        [5.1, 21.19],
                                        [4.34, 24.01],
                                        [3.27, 27.06],
                                        [1.44, 32.45],
                                        [0.01, 37.67],
                                        [2.56, 39.04],
                                        [5.66, 34.02],
                                        [8.13, 29.14],
                                        [8.4, 27.91],
                                        [9.49, 22.35],
                                        [10.22, 19.59],
                                        [11.13, 15.8],
                                        [12.63, 10],
                                        [13.81, 6.36],
                                        [14.88, 1.29],
                                        [14.87, 1.29]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [16.99, 12.47] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [18.93, 21.98] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0.02, -0.04],
                                        [0, 0],
                                        [-0.13, -0.06],
                                        [0, 0],
                                        [0, 0],
                                        [0.01, 0.03],
                                        [0.09, 0.11],
                                        [0.29, 0.14],
                                        [0.28, 0.08],
                                        [0.15, -0.06],
                                        [0.13, -0.35],
                                        [0, 0],
                                        [0, 0],
                                        [-0.09, 0],
                                        [-0.87, 0.4],
                                        [-0.79, 0.65],
                                        [-0.34, 0.49],
                                        [-0.51, 0.35],
                                        [-0.91, 0.47],
                                        [-0.12, 0.1],
                                        [-3.31, 2.2],
                                        [-0.73, 0.53],
                                        [-0.36, 0.31],
                                        [-0.3, 0.26],
                                        [-0.64, 0.83],
                                        [0.6, 0.28],
                                        [0.33, -0.09],
                                        [0.83, -0.36],
                                        [0.23, -0.12],
                                        [0.2, -0.13],
                                        [0.44, -0.32],
                                        [2.1, -1.41],
                                        [0.26, -0.32],
                                        [1.21, -0.98],
                                        [0, 0],
                                        [2.27, -1.71],
                                        [0.45, -0.39],
                                        [0.23, -0.19],
                                        [0.71, -0.51],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-0.02, -0.01],
                                        [-0.07, -0.08],
                                        [-0.18, -0.23],
                                        [-0.29, -0.13],
                                        [-0.14, -0.03],
                                        [-0.14, 0.05],
                                        [0, 0],
                                        [0, 0],
                                        [0.07, 0.03],
                                        [1.15, 0.02],
                                        [0.87, -0.41],
                                        [0.85, -0.79],
                                        [0.33, -0.48],
                                        [1.96, -1.5],
                                        [0.14, -0.07],
                                        [0.79, -0.71],
                                        [2.25, -1.67],
                                        [0.43, -0.32],
                                        [0.33, -0.29],
                                        [0.65, -0.58],
                                        [0.38, -0.45],
                                        [-0.62, -0.27],
                                        [-0.65, 0.19],
                                        [-0.21, 0.09],
                                        [-0.25, 0.14],
                                        [-0.41, 0.26],
                                        [-0.69, 0.5],
                                        [-0.34, 0.23],
                                        [-1.16, 1.39],
                                        [-1.2, 0.98],
                                        [0, 0],
                                        [-0.92, 0.75],
                                        [-0.44, 0.37],
                                        [-1.36, 1.15],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [2.14, 21.75],
                                        [2.06, 21.85],
                                        [2.81, 23.3],
                                        [2.98, 23.36],
                                        [3.1, 23.43],
                                        [3.28, 23.5],
                                        [3.22, 23.46],
                                        [3, 23.1],
                                        [2.24, 22.55],
                                        [1.37, 22.25],
                                        [0.97, 22.2],
                                        [0.48, 22.8],
                                        [0, 24.04],
                                        [2.36, 24.91],
                                        [2.61, 24.94],
                                        [5.58, 24.25],
                                        [8.04, 22.66],
                                        [9.61, 20.8],
                                        [10.74, 19.54],
                                        [17.4, 15.64],
                                        [17.78, 15.39],
                                        [25.37, 9.26],
                                        [29.75, 6.01],
                                        [30.93, 5.06],
                                        [31.87, 4.23],
                                        [33.78, 2.26],
                                        [33.38, 0.61],
                                        [31.97, 0.01],
                                        [29.71, 0.8],
                                        [29.06, 1.11],
                                        [28.41, 1.49],
                                        [27.13, 2.36],
                                        [22.54, 4.81],
                                        [21.64, 5.64],
                                        [17.82, 9.32],
                                        [15.68, 10.93],
                                        [8.06, 16.71],
                                        [6.13, 18.37],
                                        [5.16, 19.2],
                                        [2.15, 21.74],
                                        [2.14, 21.75]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 4
                },
                {
                    "ty": 4,
                    "nm": "Burst 1 Bg",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [19.5, 21.5] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [19.5, 21.5] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 0
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 36
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 54
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 90
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 108
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 144
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 162
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 198
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [100],
                                    "t": 216
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [100],
                                    "t": 252
                                },
                                {
                                    "o": { "x": 0, "y": 0 },
                                    "i": { "x": 1, "y": 1 },
                                    "s": [0],
                                    "t": 270
                                },
                                { "s": [0], "t": 306 }
                            ]
                        }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [39, 0],
                                        [39, 43],
                                        [0, 43],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [1, 1, 1] },
                            "r": 1,
                            "o": { "a": 0, "k": 0 }
                        }
                    ],
                    "ind": 5
                }
            ]
        },
        {
            "nm": "[Asset] Stars 1",
            "id": "4",
            "layers": [
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [22.96, 27.59] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [84.36, 34.11] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [-1.49, 3.7],
                                        [-2.69, 7.14],
                                        [-2.2, 5.42],
                                        [-1.22, 2.75],
                                        [-0.66, 1.37],
                                        [-0.34, 0.66],
                                        [0, 0],
                                        [-0.02, 0.03],
                                        [0, 0],
                                        [-0.04, 0.05],
                                        [-0.04, 0.04],
                                        [-0.03, -0.1],
                                        [-0.02, -0.11],
                                        [-0.01, -0.05],
                                        [0, 0],
                                        [0, 0],
                                        [-0.04, -0.15],
                                        [-0.11, -0.55],
                                        [-0.17, -0.98],
                                        [-0.12, -0.58],
                                        [-1.13, -7.11],
                                        [-0.45, -4.03],
                                        [-0.11, -2.01],
                                        [0, -0.49],
                                        [0, 0],
                                        [0.06, -0.02],
                                        [0.05, 0.04],
                                        [0, 0],
                                        [0.22, 0.17],
                                        [0.5, 0.41],
                                        [0.96, 0.7],
                                        [1.63, 0.92],
                                        [1.76, 0.69],
                                        [3.53, 0.58],
                                        [3.23, 0.03],
                                        [0.01, -0.4],
                                        [-1.73, -0.19],
                                        [-3.37, -0.72],
                                        [-3.96, -1.54],
                                        [-2.86, -1.72],
                                        [-1.64, -1.22],
                                        [-1.92, -1.61],
                                        [0, 0],
                                        [-0.33, -0.23],
                                        [-0.59, -0.06],
                                        [-0.29, 0.07],
                                        [-0.24, 0.17],
                                        [-0.09, 0.11],
                                        [-0.07, 0.13],
                                        [-0.07, 0.34],
                                        [0.02, 0.82],
                                        [0.04, 0.46],
                                        [0.1, 0.92],
                                        [0.25, 1.81],
                                        [0.48, 3.09],
                                        [0, 0],
                                        [0.49, 2.66],
                                        [0.37, 1.75],
                                        [0.22, 0.95],
                                        [0.12, 0.49],
                                        [0.09, 0.36],
                                        [0.13, 0.4],
                                        [0.4, 0.36],
                                        [0.26, 0.08],
                                        [0.08, 0.03],
                                        [0.07, -0.02],
                                        [0.12, -0.05],
                                        [0.47, -0.72],
                                        [0.11, -0.19],
                                        [0.1, -0.2],
                                        [0, 0],
                                        [0, 0],
                                        [0.82, -1.89],
                                        [1.05, -2.63],
                                        [0.9, -2.36],
                                        [1.65, -5.42],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [-1.16, 3.83],
                                        [2.12, -5.24],
                                        [2.98, -8.11],
                                        [0.92, -2.29],
                                        [0.61, -1.38],
                                        [0.33, -0.69],
                                        [0, 0],
                                        [0.04, -0.07],
                                        [0, 0],
                                        [0.04, -0.07],
                                        [0.04, -0.05],
                                        [0.03, -0.04],
                                        [0.05, 0.14],
                                        [0.01, 0.05],
                                        [0, 0],
                                        [0, 0],
                                        [0.04, 0.15],
                                        [0.13, 0.6],
                                        [0.44, 2.22],
                                        [0.1, 0.58],
                                        [0.43, 2.07],
                                        [0.56, 3.55],
                                        [0.23, 2.01],
                                        [0.02, 0.5],
                                        [0, 0],
                                        [-0.02, 0.06],
                                        [-0.07, 0.01],
                                        [0, 0],
                                        [-0.22, -0.18],
                                        [-0.53, -0.43],
                                        [-1.02, -0.82],
                                        [-1.93, -1.4],
                                        [-3.27, -1.85],
                                        [-4.17, -1.6],
                                        [-3.53, -0.57],
                                        [-1.78, -0.01],
                                        [-0.01, 0.42],
                                        [3.14, 0.35],
                                        [3.37, 0.73],
                                        [1.54, 0.59],
                                        [1.42, 0.86],
                                        [1.66, 1.22],
                                        [0, 0],
                                        [0.3, 0.24],
                                        [0.65, 0.46],
                                        [0.3, 0.04],
                                        [0.29, -0.06],
                                        [0.12, -0.09],
                                        [0.09, -0.11],
                                        [0.14, -0.26],
                                        [0.14, -0.75],
                                        [-0.02, -0.47],
                                        [-0.07, -0.92],
                                        [-0.2, -1.83],
                                        [-0.5, -3.62],
                                        [-0.96, -6.17],
                                        [0, 0],
                                        [-0.25, -1.33],
                                        [-0.19, -0.88],
                                        [-0.12, -0.48],
                                        [-0.09, -0.35],
                                        [-0.12, -0.41],
                                        [-0.26, -0.81],
                                        [-0.2, -0.19],
                                        [-0.07, -0.03],
                                        [-0.09, -0.01],
                                        [-0.13, 0.05],
                                        [-0.47, 0.15],
                                        [-0.12, 0.17],
                                        [-0.11, 0.19],
                                        [0, 0],
                                        [0, 0],
                                        [-0.96, 1.95],
                                        [-1.63, 3.79],
                                        [-3.14, 7.95],
                                        [-2.68, 7.16],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [14.64, 52],
                                        [16.59, 52.69],
                                        [23.57, 34.79],
                                        [29.21, 19.13],
                                        [32.47, 11.41],
                                        [34.37, 7.27],
                                        [35.37, 5.26],
                                        [35.5, 5.01],
                                        [35.55, 4.93],
                                        [35.61, 4.83],
                                        [35.74, 4.66],
                                        [35.86, 4.52],
                                        [36, 4.54],
                                        [36.09, 4.92],
                                        [36.1, 5.08],
                                        [36.1, 5.12],
                                        [36.15, 5.33],
                                        [36.25, 5.79],
                                        [36.61, 7.52],
                                        [37.51, 12.49],
                                        [37.83, 14.24],
                                        [40.5, 29.04],
                                        [42.1, 40.55],
                                        [42.63, 46.61],
                                        [42.69, 48.1],
                                        [42.69, 48.47],
                                        [42.61, 48.63],
                                        [42.44, 48.55],
                                        [42.34, 48.47],
                                        [41.68, 47.94],
                                        [40.14, 46.68],
                                        [37.16, 44.39],
                                        [31.81, 40.93],
                                        [24.22, 37.34],
                                        [12.72, 34.24],
                                        [2.68, 33.42],
                                        [0, 34.23],
                                        [2.58, 35.26],
                                        [12.24, 36.79],
                                        [23.18, 40.02],
                                        [29.89, 43.4],
                                        [34.51, 46.51],
                                        [39.79, 50.75],
                                        [40.35, 51.2],
                                        [41.3, 51.91],
                                        [43.21, 52.74],
                                        [44.08, 52.69],
                                        [44.91, 52.28],
                                        [45.21, 51.98],
                                        [45.46, 51.64],
                                        [45.78, 50.73],
                                        [45.9, 48.26],
                                        [45.81, 46.88],
                                        [45.55, 44.13],
                                        [44.86, 38.65],
                                        [43.35, 28.42],
                                        [41.62, 17.81],
                                        [40.83, 13.49],
                                        [39.9, 8.84],
                                        [39.3, 6.11],
                                        [38.94, 4.66],
                                        [38.66, 3.59],
                                        [38.29, 2.36],
                                        [37.27, 0.48],
                                        [36.62, 0.07],
                                        [36.39, 0],
                                        [36.17, 0.04],
                                        [35.8, 0.18],
                                        [34.36, 1.54],
                                        [34.02, 2.09],
                                        [33.69, 2.68],
                                        [33.37, 3.28],
                                        [33.08, 3.85],
                                        [30.44, 9.66],
                                        [26.34, 19.62],
                                        [20.88, 33.78],
                                        [14.65, 52],
                                        [14.64, 52]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [31.86, 14.48] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [87.8, 29.25] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [-1.64, 0.66],
                                        [-1.26, 0.57],
                                        [-1.52, 0.74],
                                        [-0.9, 0.53],
                                        [-1.19, 0.51],
                                        [-1.7, 0.54],
                                        [-0.25, 0.11],
                                        [-6.68, 2.64],
                                        [-1.49, 0.63],
                                        [-0.75, 0.33],
                                        [-1.38, 0.74],
                                        [-1.2, 0.77],
                                        [1.46, -0.52],
                                        [1.43, -0.58],
                                        [1.76, -0.78],
                                        [1.42, -0.52],
                                        [2.04, -0.8],
                                        [0.63, -0.33],
                                        [2.55, -1.04],
                                        [0, 0],
                                        [3.35, -1.34],
                                        [2.3, -1.05],
                                        [0.66, -0.3],
                                        [0.49, -0.23],
                                        [0.51, -0.24],
                                        [1.22, -0.68],
                                        [1.06, -0.69],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [-1.5, 0.98],
                                        [1.17, -0.46],
                                        [1.27, -0.55],
                                        [1.7, -0.85],
                                        [0.91, -0.51],
                                        [3.99, -1.8],
                                        [0.25, -0.08],
                                        [1.72, -0.77],
                                        [2.34, -0.96],
                                        [1.48, -0.67],
                                        [1.77, -0.79],
                                        [1.38, -0.75],
                                        [1.32, -0.85],
                                        [-1.34, 0.47],
                                        [-1.44, 0.57],
                                        [-0.68, 0.3],
                                        [-1.43, 0.49],
                                        [-0.67, 0.26],
                                        [-2.72, 1.42],
                                        [-2.56, 1.04],
                                        [0, 0],
                                        [-3.34, 1.37],
                                        [-0.87, 0.39],
                                        [-0.66, 0.31],
                                        [-0.97, 0.46],
                                        [-1.53, 0.75],
                                        [-1.22, 0.7],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0.78, 26.96],
                                        [1.75, 28.8],
                                        [5.36, 27.25],
                                        [9.5, 25.33],
                                        [13.14, 23.35],
                                        [16.01, 21.89],
                                        [28.73, 17.21],
                                        [29.47, 16.93],
                                        [45.52, 10.3],
                                        [51.24, 7.86],
                                        [54.56, 6.37],
                                        [59.21, 4.05],
                                        [63.02, 1.77],
                                        [62.19, 0.12],
                                        [58.1, 1.71],
                                        [53.38, 3.75],
                                        [50.18, 4.95],
                                        [44.95, 6.89],
                                        [43.01, 7.78],
                                        [34.49, 11.64],
                                        [30.07, 13.37],
                                        [23.95, 15.82],
                                        [14.39, 19.89],
                                        [12.11, 20.92],
                                        [10.41, 21.72],
                                        [8.26, 22.73],
                                        [4.17, 24.88],
                                        [0.8, 26.96],
                                        [0.78, 26.96]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [22.23, 23.41] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [98.02, 38.51] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0.17, 0.27],
                                        [0.22, -0.06],
                                        [0.3, -0.56],
                                        [0.75, -0.98],
                                        [0.97, -1.2],
                                        [1.6, -1.78],
                                        [1.23, -1.1],
                                        [0.16, -0.18],
                                        [4.83, -4.48],
                                        [1.11, -1.01],
                                        [1.02, -0.98],
                                        [0.91, -0.82],
                                        [-0.14, -0.4],
                                        [-0.68, 0.37],
                                        [-1.17, 0.88],
                                        [-1.33, 1.2],
                                        [-3, 2.79],
                                        [-0.43, 0.51],
                                        [-1.78, 1.84],
                                        [0, 0],
                                        [-2.29, 2.44],
                                        [-1.54, 1.77],
                                        [-0.66, 0.82],
                                        [-0.7, 1.13],
                                        [-0.37, 1.29],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0.13, -0.45],
                                        [-0.19, -0.3],
                                        [-0.47, 0.21],
                                        [-0.46, 0.82],
                                        [-0.76, 0.98],
                                        [-2.13, 2.77],
                                        [-2.65, 3.06],
                                        [-0.18, 0.16],
                                        [-1.15, 1.31],
                                        [-3.34, 3.23],
                                        [-1.31, 1.2],
                                        [-1.02, 0.98],
                                        [-0.5, 0.45],
                                        [0.13, 0.39],
                                        [1.22, -0.65],
                                        [1.16, -0.88],
                                        [1.03, -0.94],
                                        [0.49, -0.46],
                                        [1.85, -2.19],
                                        [1.78, -1.84],
                                        [0, 0],
                                        [2.29, -2.43],
                                        [2.31, -2.66],
                                        [0.98, -1.24],
                                        [0.69, -1.14],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [44.4, 1.5],
                                        [44.29, 0.31],
                                        [43.61, 0.02],
                                        [42.46, 0.78],
                                        [40.55, 3.51],
                                        [37.97, 6.76],
                                        [33.91, 12.19],
                                        [24.99, 20.98],
                                        [24.47, 21.5],
                                        [13.33, 32.95],
                                        [6.76, 39.14],
                                        [3.31, 42.38],
                                        [0.46, 45.11],
                                        [0.07, 46.41],
                                        [1.5, 46.64],
                                        [4.99, 44.35],
                                        [8.69, 41.26],
                                        [15.15, 35.88],
                                        [16.52, 34.43],
                                        [22.41, 28.02],
                                        [25.5, 24.88],
                                        [29.72, 20.46],
                                        [36.19, 13.35],
                                        [40.22, 8.54],
                                        [42.73, 5],
                                        [44.4, 1.49],
                                        [44.4, 1.5]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 3
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [8.96, 22.15] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [15.22, 24.53] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [-0.55, 1.07],
                                        [-0.79, 2.14],
                                        [-0.66, 1.63],
                                        [-0.55, 1.09],
                                        [-0.06, 0.17],
                                        [-1.87, 4.5],
                                        [-0.37, 1.05],
                                        [-0.3, 1.94],
                                        [0.5, -0.94],
                                        [0.91, -2.44],
                                        [1.14, -2.75],
                                        [0.12, -0.47],
                                        [0, 0],
                                        [1.21, -3.21],
                                        [0.26, -0.72],
                                        [0.29, -1.71],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [-0.21, 1.2],
                                        [0.77, -1.53],
                                        [0.8, -2.46],
                                        [1.05, -2.79],
                                        [0.08, -0.16],
                                        [0.41, -1.22],
                                        [1.23, -3.21],
                                        [0.9, -2.48],
                                        [0.16, -1.06],
                                        [-0.91, 1.72],
                                        [-0.35, 0.95],
                                        [-0.18, 0.45],
                                        [-0.99, 4.08],
                                        [0, 0],
                                        [-0.91, 2.41],
                                        [-0.78, 2.18],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0.02, 43.07],
                                        [1.99, 43.72],
                                        [4.25, 38.42],
                                        [5.62, 33.6],
                                        [9.53, 25.23],
                                        [9.74, 24.73],
                                        [13.88, 13.69],
                                        [16.23, 7.43],
                                        [17.9, 1.08],
                                        [16.14, 0.51],
                                        [13.54, 6.44],
                                        [10.93, 11.98],
                                        [10.48, 13.36],
                                        [7.34, 22.41],
                                        [3.13, 33.13],
                                        [1.54, 37.43],
                                        [0.02, 43.07],
                                        [0.02, 43.07]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 4
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [5.38, 19.71] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [27.27, 20.24] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0.03, -1.05],
                                        [-0.32, -1.96],
                                        [-0.23, -1.51],
                                        [-0.12, -1.05],
                                        [-0.05, -0.15],
                                        [-0.99, -4.07],
                                        [-0.27, -0.91],
                                        [-0.82, -1.47],
                                        [0.11, 0.91],
                                        [0.62, 2.14],
                                        [0.59, 2.47],
                                        [0.17, 0.38],
                                        [0.4, 1.54],
                                        [0, 0],
                                        [0.43, 2.04],
                                        [0.27, 1.43],
                                        [0.11, 0.63],
                                        [0.46, 1.4],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [-0.32, -0.99],
                                        [-0.05, 1.49],
                                        [0.45, 2.21],
                                        [0.46, 2.52],
                                        [0.02, 0.15],
                                        [0.3, 1.07],
                                        [0.77, 2.85],
                                        [0.66, 2.16],
                                        [0.45, 0.81],
                                        [-0.2, -1.66],
                                        [-0.25, -0.83],
                                        [-0.1, -0.4],
                                        [-0.72, -1.64],
                                        [-0.4, -1.55],
                                        [0, 0],
                                        [-0.44, -2.04],
                                        [-0.4, -2.15],
                                        [-0.33, -1.93],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [2.06, 0.63],
                                        [0.01, 0.92],
                                        [0.37, 5.92],
                                        [1.52, 10.11],
                                        [2.54, 18.03],
                                        [2.63, 18.48],
                                        [5.26, 28.29],
                                        [6.84, 33.81],
                                        [9, 39],
                                        [10.76, 38.42],
                                        [9.6, 32.99],
                                        [8.63, 27.84],
                                        [8.23, 26.67],
                                        [6.5, 21.53],
                                        [5.87, 18.85],
                                        [5.05, 15.13],
                                        [3.89, 9.27],
                                        [3.21, 5.44],
                                        [2.06, 0.63],
                                        [2.06, 0.63]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 5
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [17.09, 11.2] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [17.15, 30.61] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0.62, 0.92],
                                        [0.25, 0.32],
                                        [0.29, 0.31],
                                        [0.33, 0.32],
                                        [0.39, 0.32],
                                        [0.34, 0.2],
                                        [0.28, 0.14],
                                        [0.6, 0.46],
                                        [0.83, 0.63],
                                        [0.13, 0.08],
                                        [3.56, 2.11],
                                        [0.83, 0.44],
                                        [1.63, 0.44],
                                        [-0.71, -0.54],
                                        [-1.95, -1.05],
                                        [-2.17, -1.29],
                                        [-0.38, -0.14],
                                        [-1.38, -0.77],
                                        [0, 0],
                                        [-0.58, -0.36],
                                        [-0.87, -0.55],
                                        [-0.86, -0.58],
                                        [-0.58, -0.41],
                                        [-0.49, -0.36],
                                        [-0.25, -0.19],
                                        [-0.34, -0.26],
                                        [-0.31, -0.23],
                                        [-0.29, -0.22],
                                        [-0.29, -0.2],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0.79, 0.57],
                                        [-0.22, -0.32],
                                        [-0.25, -0.32],
                                        [-0.29, -0.3],
                                        [-0.34, -0.3],
                                        [-0.46, -0.34],
                                        [-0.34, -0.19],
                                        [-0.55, -0.28],
                                        [-2.09, -1.47],
                                        [-0.12, -0.1],
                                        [-0.97, -0.53],
                                        [-2.56, -1.42],
                                        [-1.98, -1.04],
                                        [-0.91, -0.24],
                                        [1.3, 1],
                                        [0.76, 0.4],
                                        [0.35, 0.21],
                                        [1.67, 0.61],
                                        [1.37, 0.79],
                                        [0, 0],
                                        [0.58, 0.36],
                                        [0.86, 0.56],
                                        [0.86, 0.59],
                                        [0.87, 0.63],
                                        [0.47, 0.37],
                                        [0.37, 0.3],
                                        [0.33, 0.27],
                                        [0.31, 0.24],
                                        [0.28, 0.23],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [32.5, 22.23],
                                        [34.02, 20.82],
                                        [33.33, 19.86],
                                        [32.51, 18.95],
                                        [31.58, 18.02],
                                        [30.48, 17.1],
                                        [29.3, 16.3],
                                        [28.38, 15.81],
                                        [26.77, 14.82],
                                        [20.47, 9.99],
                                        [20.09, 9.73],
                                        [11.29, 4.82],
                                        [6.3, 2.11],
                                        [1.12, 0.03],
                                        [0.31, 1.69],
                                        [4.95, 4.65],
                                        [9.26, 7.54],
                                        [10.37, 8.07],
                                        [15.22, 10.39],
                                        [17.55, 11.8],
                                        [18.49, 12.38],
                                        [20.74, 13.79],
                                        [23.4, 15.54],
                                        [25.64, 17.08],
                                        [27.63, 18.53],
                                        [28.68, 19.36],
                                        [29.76, 20.18],
                                        [30.71, 20.92],
                                        [31.63, 21.59],
                                        [32.48, 22.23],
                                        [32.5, 22.23]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 6
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [21.67, 3.95] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [21.96, 18.37] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [-1.12, 0],
                                        [-2.1, 0.3],
                                        [-1.62, 0.19],
                                        [-1.13, 0.03],
                                        [-0.16, 0.03],
                                        [-4.48, 0.5],
                                        [-1.02, 0.15],
                                        [-1.72, 0.61],
                                        [0.99, 0.02],
                                        [2.4, -0.33],
                                        [2.75, -0.31],
                                        [0.44, -0.12],
                                        [0, 0],
                                        [3.14, -0.42],
                                        [0.7, -0.1],
                                        [1.52, -0.5],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [-1.08, 0.35],
                                        [1.59, 0],
                                        [2.37, -0.44],
                                        [2.73, -0.39],
                                        [0.17, 0],
                                        [1.17, -0.23],
                                        [3.15, -0.46],
                                        [2.41, -0.36],
                                        [0.94, -0.33],
                                        [-1.8, -0.04],
                                        [-0.93, 0.14],
                                        [-0.45, 0.05],
                                        [-3.75, 1.08],
                                        [0, 0],
                                        [-2.36, 0.35],
                                        [-2.11, 0.32],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [0.67, 5.85],
                                        [1.01, 7.9],
                                        [6.36, 7.48],
                                        [10.9, 6.42],
                                        [19.45, 5.85],
                                        [19.95, 5.8],
                                        [30.74, 4.14],
                                        [36.87, 3.26],
                                        [42.76, 1.83],
                                        [42.46, 0.01],
                                        [36.45, 0.41],
                                        [30.77, 0.73],
                                        [29.45, 1],
                                        [20.7, 2.59],
                                        [10.13, 4.02],
                                        [5.94, 4.64],
                                        [0.68, 5.85],
                                        [0.67, 5.85]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 7
                },
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [19.02, 16.05] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [24.71, 30.63] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [1.09, -0.63],
                                        [1.88, -1.46],
                                        [1.46, -1.1],
                                        [1.05, -0.71],
                                        [0.14, -0.12],
                                        [3.9, -3.23],
                                        [0.85, -0.78],
                                        [1.22, -1.61],
                                        [-0.92, 0.62],
                                        [-2.01, 1.8],
                                        [-2.38, 1.97],
                                        [-0.34, 0.37],
                                        [0, 0],
                                        [-1.98, 1.59],
                                        [-1.39, 1.1],
                                        [-0.62, 0.49],
                                        [-1.23, 1.3],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0.87, -0.92],
                                        [-1.54, 0.9],
                                        [-2.07, 1.74],
                                        [-2.44, 1.91],
                                        [-0.16, 0.1],
                                        [-1, 0.89],
                                        [-2.7, 2.34],
                                        [-2.01, 1.84],
                                        [-0.68, 0.89],
                                        [1.66, -1.13],
                                        [0.78, -0.71],
                                        [0.39, -0.32],
                                        [2.89, -3.24],
                                        [0, 0],
                                        [1.99, -1.57],
                                        [2.09, -1.65],
                                        [1.87, -1.48],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [37.73, 1.79],
                                        [36.45, 0.16],
                                        [31.49, 3.57],
                                        [27.63, 7.1],
                                        [19.76, 12.61],
                                        [19.31, 12.95],
                                        [10.02, 20.97],
                                        [4.83, 25.59],
                                        [0.22, 30.57],
                                        [1.49, 31.91],
                                        [6.76, 27.72],
                                        [11.81, 23.89],
                                        [12.89, 22.84],
                                        [20.24, 16.19],
                                        [23.84, 13.29],
                                        [29.55, 8.77],
                                        [33.27, 5.84],
                                        [37.74, 1.8],
                                        [37.73, 1.79]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 8
                },
                {
                    "ty": 4,
                    "nm": "Stars 1 Bg",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [60.5, 31] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [60.5, 31] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 0
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 36
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 54
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 90
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 108
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 144
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [100],
                                    "t": 162
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [100],
                                    "t": 198
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 216
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 252
                                },
                                {
                                    "o": { "x": 0, "y": 0 },
                                    "i": { "x": 1, "y": 1 },
                                    "s": [0],
                                    "t": 270
                                },
                                { "s": [0], "t": 306 }
                            ]
                        }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [121, 0],
                                        [121, 62],
                                        [0, 62],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [1, 1, 1] },
                            "r": 1,
                            "o": { "a": 0, "k": 0 }
                        }
                    ],
                    "ind": 9
                }
            ]
        },
        {
            "nm": "[Asset] scribble 1",
            "id": "5",
            "layers": [
                {
                    "ty": 4,
                    "nm": "Vector",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [87.36, 20.24] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [87.46, 20.84] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": { "a": 0, "k": 100 }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [10.71, 6.92],
                                        [-26.09, -25.73],
                                        [12.74, 10.47],
                                        [-13.15, -32.72],
                                        [8.14, 1.08],
                                        [-1.73, -0.68],
                                        [3.65, 0.71],
                                        [-0.34, 0.09],
                                        [3.14, 3.86],
                                        [5.14, 6.42],
                                        [3.73, -2.56],
                                        [-0.12, 0.1],
                                        [-4.14, -5.39],
                                        [10.47, 1.16],
                                        [-2.13, -0.19],
                                        [0, 0],
                                        [-7.22, 6.46],
                                        [-1.79, 1.09],
                                        [4.41, 2.18],
                                        [-8.08, 8.34],
                                        [-13.66, 4.74],
                                        [0, 0],
                                        [-3.33, 2.95],
                                        [-5.79, 9.35],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [-12.23, 2.62],
                                        [17.37, -30.65],
                                        [-12.75, 9.08],
                                        [29.03, -33.6],
                                        [-1.54, 2.02],
                                        [1.73, 0.42],
                                        [-3.84, 0.62],
                                        [0.18, -0.59],
                                        [-3.12, -0.3],
                                        [4.32, -3.71],
                                        [-3.68, -2.93],
                                        [0.09, -0.14],
                                        [-6.3, 2.9],
                                        [-9.53, 6.42],
                                        [0.02, 0.88],
                                        [0, 0],
                                        [10.18, -0.6],
                                        [0.02, 0.62],
                                        [0.66, 1.06],
                                        [11.3, 11.18],
                                        [11.76, 10.71],
                                        [0, 0],
                                        [3.13, -1.1],
                                        [8.33, 5.8],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [174.71, 30.23],
                                        [137.68, 23.67],
                                        [131.93, 23.55],
                                        [84.9, 25.2],
                                        [79.44, 24.54],
                                        [53.86, 34.12],
                                        [60.14, 34.33],
                                        [48.66, 34.28],
                                        [51.26, 34.15],
                                        [35.81, 27.16],
                                        [46.17, 8.9],
                                        [34.42, 9.17],
                                        [35.38, 8.11],
                                        [31.77, 26.36],
                                        [0, 38.75],
                                        [4.3, 40.15],
                                        [3.5, 40.48],
                                        [30.64, 29.47],
                                        [33.63, 28.62],
                                        [36.19, 31.45],
                                        [82.07, 27.91],
                                        [126.58, 32.15],
                                        [126.22, 32.15],
                                        [135.45, 26.09],
                                        [174.71, 30.21],
                                        [174.71, 30.23]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [-8, -5.63],
                                        [3.8, -3.55]
                                    ],
                                    "o": [
                                        [-5.14, -6.94],
                                        [0.21, 5.69],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [33.93, 24.75],
                                        [44.96, 11.01],
                                        [33.93, 24.75]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [-0.02, 0.02],
                                        [-9.1, -4.14],
                                        [0.78, -0.86],
                                        [4.01, -3.17]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [-5.58, -6.06],
                                        [-1.5, -1.22],
                                        [12.7, -6.73],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [81.5, 22.57],
                                        [81.55, 22.51],
                                        [90.35, 3.59],
                                        [84.61, 5.16],
                                        [81.5, 22.57]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [1.4, -1.53],
                                        [1.11, 2.7],
                                        [-0.04, 0.36],
                                        [0, 0],
                                        [-4.2, -5.29],
                                        [0.03, -0.02],
                                        [0.71, -2.86]
                                    ],
                                    "o": [
                                        [-0.48, 1.91],
                                        [-2.3, -1.84],
                                        [-0.16, 0.22],
                                        [0, 0],
                                        [-2.94, -5.56],
                                        [0, -0.03],
                                        [1.53, 2.49],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [137.35, 15.89],
                                        [134.38, 21.27],
                                        [128.71, 14.31],
                                        [128.26, 13.91],
                                        [128.56, 13.92],
                                        [136.7, 7.68],
                                        [136.02, 7.33],
                                        [137.35, 15.89]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [0.0628, 0.0706, 0.0785] },
                            "r": 1,
                            "o": { "a": 0, "k": 100 }
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "scribble 1 Bg",
                    "sr": 1,
                    "st": 0,
                    "op": 271,
                    "ip": 0,
                    "hd": false,
                    "ddd": 0,
                    "bm": 0,
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": { "a": 0, "k": [87.5, 21] },
                        "s": { "a": 0, "k": [100, 100] },
                        "sk": { "a": 0, "k": 0 },
                        "p": { "a": 0, "k": [87.5, 21] },
                        "r": { "a": 0, "k": 0 },
                        "sa": { "a": 0, "k": 0 },
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 0
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 36
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [100],
                                    "t": 54
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [100],
                                    "t": 90
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 108
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 144
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 162
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 198
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 216
                                },
                                {
                                    "o": { "x": 0.65, "y": 0 },
                                    "i": { "x": 0.35, "y": 0 },
                                    "s": [0],
                                    "t": 252
                                },
                                {
                                    "o": { "x": 0, "y": 0 },
                                    "i": { "x": 1, "y": 1 },
                                    "s": [0],
                                    "t": 270
                                },
                                { "s": [0], "t": 306 }
                            ]
                        }
                    },
                    "shapes": [
                        {
                            "ty": "sh",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "d": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "c": true,
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [175, 0],
                                        [175, 42],
                                        [0, 42],
                                        [0, 0]
                                    ]
                                }
                            }
                        },
                        {
                            "ty": "fl",
                            "bm": 0,
                            "hd": false,
                            "nm": "",
                            "c": { "a": 0, "k": [1, 1, 1] },
                            "r": 1,
                            "o": { "a": 0, "k": 0 }
                        }
                    ],
                    "ind": 2
                }
            ]
        }
    ]
}
